export enum BackOfficeRoutes {
    ROOT = 'back-office',
    DATA_DELIVERY = 'data-delivery',
    ORGANIZATION_METADATA = 'organization-metadata'
}
